import { IApplicationState } from '../../types/redux';

export const selectOffersByRealtyOfferIdStatus = (state: IApplicationState) => state.offersByRealtyOfferId.status;
